import { Box } from "@mui/material";
import { text } from "../../../theme/colours";

const Bubble = ({ currBubble, radius, i, setCurrBubble }) => {
  const bubbleStyle = {
    width: radius,
    height: radius,
    borderRadius: "25px",
    background: text.primary,
    opacity: currBubble === i ? 1 : 0.31,
    m: "0.25rem",
  };

  const setBubble = () => {
    setCurrBubble(i);
  };

  return <Box sx={bubbleStyle} onClick={() => setBubble()} />;
};

export default Bubble;
